import { DatePicker, IDatePickerStrings, Dropdown, TextField, defaultDatePickerStrings, ChoiceGroup, DropdownMenuItemType } from '@fluentui/react'
import { addMonths } from 'date-fns';
import React, { useContext, useEffect, useState,useRef } from 'react';
import { useConst } from '@fluentui/react-hooks';
import { useTranslation } from 'react-i18next';
import userContext from '../../../../context/users/UserContext';
import { USERTYPES } from '../../../../constants/Constants';
import CustomSelect from '../../../../components/CustomSelect';
import CustomeMultiSelect from '../../../../components/CustomMultiSelect';
import themeContext from '../../../../context/theme/ThemeContext';
import studylistContext from '../../../../context/studylist/StudylistContext';
import { choiceGroupStyles } from '../../../Report/helper/initialData';
import { color } from 'd3';

const ExportCsvBody = (props) => {

    const enterprise = (process.env.REACT_APP_ENTERPRISE_PLATFORM=="true"||process.env.REACT_APP_ENTERPRISE_PLATFORM==true)?true:false;
    const {roles} = useContext(userContext);
    const { getThemeColor } = useContext(themeContext);
    const [t] = useTranslation();
    const today = new Date();
    const {clientFirmList, filterInputValues} = useContext(studylistContext);
    const [clientOptions, setClientOptions] = useState([]);
    const [providerOptions, setProviderOptions] = useState([]);
    const dropdownRef1 = useRef(null);
    const dropdownRef2 = useRef(null);
    const divRef1 = useRef(null);
    const divRef2 = useRef(null);
   
    // const minDate = useConst(addMonths(today, -3));
    const maxDate = today;

    const datePickerStyles = { root: { maxWidth: 300, marginTop: 15 } };

    // const strings = useConst(() => ({
    //     ...defaultDatePickerStrings,
    //     isOutOfBoundsErrorMessage: `Date must be between ${minDate.toLocaleDateString()} and ${maxDate.toLocaleDateString()}`,
    // }));

    const uploadDateFromFunction = (event) => {
        props.setErrorMessage("");
        props.setFilterObj({ ...props.filterObj, uploadDateFrom: event });
        props.setValues({
            ...props.values,
            uploadDateFrom: event
          });
        props.setErrors({
            ...props.errors,
            uploadDateFrom: null
        })
    };

    useEffect(() => {
      if (clientFirmList.length > 0) {
        let tempClientOptions = [];
        clientFirmList.map((item) =>{tempClientOptions.push({key : item.id, text : item.name})})
        setClientOptions(tempClientOptions);
      }

      if (Object.keys(filterInputValues)?.length > 0) {
        let tempProvidersList = [];
        filterInputValues?.radiologistList?.map((item) => {
          tempProvidersList.push({
            key: item.name!=undefined ? "F" + item.id : "R" + item.id,
            text: item.name!=undefined ? item.name : item.firstName + " " + item.lastName
          });
        });
        setProviderOptions(tempProvidersList);
      }
    }, [clientFirmList, filterInputValues]);

    const uploadDateToFunction = (event) => {
        props.setErrorMessage("");
        props.setFilterObj({ ...props.filterObj, uploadDateTo: event });
        props.setValues({
            ...props.values,
            uploadDateTo: event
          });
        props.setErrors({
            ...props.errors,
            uploadDateTo: null
        })
    };
    const tabOptions =[
        { key: 'dptk_allstudiestab', text: 'All Data' },
        { key: 'dptk_reportedstudiestab', text: 'Only Reported Data' }
    ];
    const handleClickOutside = (event) => {
      event.stopPropagation();
      console.log('clicking outside', event);
      console.log('div ref', divRef1);
      if (divRef1.current && dropdownRef1.current && !divRef1.current.contains(event.target)) {
        dropdownRef1.current.dismissMenu();
        console.log('if.................')
      }
      if (divRef2.current && dropdownRef2.current && !divRef2.current.contains(event.target)) {
        dropdownRef2.current.dismissMenu();
        console.log('if.................')
      }
      
    };

  return (
    <div className="close-study-container" onClick={handleClickOutside}>
      <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row">
          <DatePicker
            className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
            value={props.filterObj.uploadDateFrom}
            name="uploadDateFrom"
            style={datePickerStyles}
            onSelectDate={uploadDateFromFunction}
            //strings={strings}
            placeholder="dd-mmm-yyyy"
            // minDate={minDate}
            maxDate={maxDate}
            label={
              <span>
                {t("export-csv.upload-date-from")}
                <span style={{ marginLeft: "4px", color: "red" }}>*</span>
              </span>
            }
            // label={t("export-csv.upload-date-from")}
            formatDate={(date) => {
              const day = date.getDate().toString().padStart(2, "0");
              const month = new Intl.DateTimeFormat("en", {
                month: "short",
              }).format(date);
              const year = date.getFullYear();
              return `${day}-${month}-${year}`;
            }}
            // isRequired
            textField={{
              errorMessage: props.errors.uploadDateFrom
                ? props.errors.uploadDateFrom
                : undefined,
            }}
          />
        </div>
        <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
          <DatePicker
            className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
            value={props.filterObj.uploadDateTo}
            name="uploadDateTo"
            onSelectDate={uploadDateToFunction}
            //strings={strings}
            placeholder="dd-mmm-yyyy"
            // minDate={minDate}
            maxDate={maxDate}
            formatDate={(date) => {
              const day = date.getDate().toString().padStart(2, "0");
              const month = new Intl.DateTimeFormat("en", {
                month: "short",
              }).format(date);
              const year = date.getFullYear();
              return `${day}-${month}-${year}`;
            }}
            label={
              <span>
                {t("export-csv.upload-date-to")}
                <span style={{ marginLeft: "4px", color: "red" }}>*</span>
              </span>
            }
            // label={t("export-csv.upload-date-to")}
            // isRequired
            textField={{
              errorMessage: props.errors.uploadDateTo
                ? props.errors.uploadDateTo
                : undefined,
            }}
          />
        </div>
        {(enterprise
          ? roles[0] === USERTYPES.FIRMADMIN
          : roles[0] === USERTYPES.ADMIN) && (
          <>
            <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
              <div
                style={{ color: getThemeColor("primary-color") }}
                className="upload-study-body-label"
              >
                {t("user.firm")}
              </div>
              <CustomSelect
                options={props.finalFirmList}
                defaultValue={null}
                value={props.selectedFirmObj}
                label={t("user.firm")}
                placeholder="Select Firm"
                errorState={props.errorState}
                maxHeight="30px"
                onChange={(selection) => {
                  console.log("--- Selection ---", selection);
                  props.setSelectedFirm(selection.value);
                  props.setSelectedFirmObj(selection);
                }}
              />
            </div>
          </>
        )}
        {roles[0] === USERTYPES.FIRMADMIN && (
          <div className="ms-Grid-row" ref={divRef1} style={{ marginButtom: "10px" }}>
            <CustomeMultiSelect
            customClassName={"form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"}
            dropdownRef = {dropdownRef1}
            options ={clientOptions}
            placeholder ="Select Clients"
            selectedKeys ={props.selectedClientList}
            setSelectedKeys={props.setSelectedClientList}
            label={"Clients"}

            />
          </div>
        )}
        {roles[0] === USERTYPES.FIRMADMIN && (
          <div className="ms-Grid-row" ref={divRef2} style={{ marginButtom: "10px" }}>
            <CustomeMultiSelect
            customClassName={"form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"}
            dropdownRef = {dropdownRef2}
            options ={providerOptions}
            placeholder ="Select Providers"
            selectedKeys ={props.selectedProviderList}
            setSelectedKeys={props.setSelectedProviderList}
            label={"Providers"}
            />
          </div>
        )}
        {roles[0] === USERTYPES.FIRMADMIN && (
          <div
            className="ms-Grid-row"
            style={{ marginButtom: "10px", marginLeft: "4px" }}
          >
            <ChoiceGroup
              defaultSelectedKey="dptk_allstudiestab"
              styles={choiceGroupStyles}
              options={tabOptions}
              onChange={(ev, item) => {
                props.setSelectedTabOption(item.key);
              }}
              label=""
            />
          </div>
        )}
      </div>
      <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12">
        <div className="form-mt-10 custom-required-error-msg">
          {props.errorMessage}
        </div>
      </div>
    </div>
  );
}

export default ExportCsvBody